import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

var _excluded = ["align", "inline"];
var IconVIP = function IconVIP(_ref) {
  var align = _ref.align,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    props = _objectWithoutProperties(_ref, _excluded);
  var className = classnames('tds-icon', _defineProperty({
    'tds-icon--inline': inline
  }, "tds-icon--".concat(align), align), 'tds-icon-vip', props.className);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    className: className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5223 3.37092C11.6675 2.90108 12.3325 2.90108 12.4777 3.37092L14.3607 9.46433H20.5219C21.0001 9.46433 21.2054 10.0713 20.8254 10.3617L15.8197 14.1857L17.7185 20.3304C17.8622 20.7955 17.3241 21.1709 16.9372 20.8754L12 17.1037L7.06276 20.8754C6.67591 21.1709 6.13779 20.7955 6.28151 20.3304L8.18034 14.1857L3.17462 10.3617C2.79456 10.0713 2.99988 9.46433 3.47815 9.46433H9.63932L11.5223 3.37092Z",
    fill: "#3E6AE1"
  }));
};
IconVIP.propTypes = {
  className: PropTypes.string.isRequired,
  align: PropTypes.bool.isRequired,
  inline: PropTypes.bool.isRequired
};

export { IconVIP as default };
